import React from "react";

import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { useFormContext } from "react-hook-form";
import { GridLegacy } from "@mui/material";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";

function Tags() {
  const { vestigingId } = useFormContext();

  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <FormAsyncTC
              async={{
                url:
                  "core/tags/search?fields=id as value, tagName as label&per_page=50&sort_field=tagName&vestiging_id=" +
                  vestigingId,
                searchField: "tagName",
              }}
              key={"taglist" + vestigingId}
              multiple={true}
              name={"taglist"}
              tDefault={"Tag selection"}
              tKey={"producten.form.menu.label.tagSelection"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Tags;
